import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { FormattedMessage } from "react-intl";
import { useValidationErrorHandle } from "sr/helpers/functions/validationErrorHandle";
import { CheckBox } from "sr/helpers/ui-components/company/CheckBox";
import CheckBoxHandle from "sr/helpers/functions/CheckBoxHandle";
import { getBusinessType } from "sr/utils/api/masterData/getBusinessType";

type Props = {
  data: { business_types?: string[] };
  HandleDataProps: (payload: { business_types: string[] }) => void;
  externalErrorId?: string;
};

const RequirementBusinessTypesChange = forwardRef(({ data, HandleDataProps, externalErrorId }: Props, ref) => {
  const validationErrorHandle = useValidationErrorHandle();
  const [selected, setSelected] = useState<string[]>([]);
  const [options, setOptions] = useState<{value:string; label:string}[]>([]);
  const [error, setError] = useState("");

  useEffect(() => {
    setSelected(data?.business_types || []);
  }, [data?.business_types]);

  useEffect(() => {
    HandleDataProps({ business_types: selected });
  }, [selected]);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const res = await getBusinessType();
        if (res?.success && Array.isArray(res.data)) {
          const mapped = res.data.map((item: any) => ({
            value: item?.value || item?.id || item?.name,
            label: item?.label || item?.name || String(item?.value || item?.id || item),
          }));
          setOptions(mapped);
        }
      } catch {}
    };
    fetchOptions();
  }, []);

  useImperativeHandle(ref, () => ({
    validateData: () => {
      if (!selected || selected.length === 0) {
        setError("Please select at least one Business Type");
        return false;
      }
      setError("");
      return true;
    },
    submitForm: () => ({ business_types: selected }),
  }));

  return (
    <div>
      <p className="pt-4 text-base">Business Types</p>
      <div className="flex flex-wrap gap-4 mt-2">
        {options.map((bt, index) => (
          <CheckBox
            key={index}
            value={bt.value}   
            label={<FormattedMessage id={bt.label} defaultMessage={bt.label} />} 
            onChange={(e) => CheckBoxHandle(e, selected, setSelected)}
            checked={selected.includes(bt.value)}
          />
        ))}
      </div>
      {(externalErrorId || error) && <div className="text-red-500 text-sm mt-2">{externalErrorId ? validationErrorHandle(externalErrorId) : error}</div>}
    </div>
  );
});

export default RequirementBusinessTypesChange;
